import { gsap } from 'gsap';
import './navi-bootstrap-offcanvas.scss';


$('.menu-item-has-children>a').on('click', (e) => {
    e.preventDefault();
    const parent = $(e.target).parent();
    const subList = parent.find('ul.sub-menu');
    subList.slideToggle('slow')
})

$('.menu-item-has-children ul').css({
    display: 'none'
})

let startAngle = 0;
$('.hamburger-indy').on('mouseenter', () => {
    gsap.ticker.add(rotate)
})

$('.hamburger-indy').on('mouseleave', () => {
    gsap.ticker.remove(rotate)
})

const rotate = () => {
    gsap.set('.hamburger-indy', {
        rotate: startAngle += .25
    })
}

// Close Nav on click

const $navlinks = [...document.querySelectorAll('.offcanvas-body li a')];

$navlinks.forEach((link) => {
    link.addEventListener('click', () => {
        document.querySelector('.btn-close').click();
    })
})